import styled from "styled-components";

export const WrapperPage2 = styled.section`
   display: flex;
    width: 100%;
   height: 100%;
   justify-items: center;
   align-items: center;
 
`;

export const ApresentacaoContainerTexto = styled.article`
   display: flex;
    flex-direction: column;
   width: 40%;
   height: 100%;
   justify-items: center;
   justify-content: center;
   margin-left: 80px;
   
   h2{
   font-size: 45px;
   margin: 0;
   }
   
   p{
     width: 80%;
     font-size: 19px;
     color: #373737
   }
   img{
   margin-right: 20px;
   }
`;




export const ApresentacaoImagem = styled.div`
   display: flex;
   width: 50%;
   height: 100%;
   margin-bottom: 10px;
  align-content: end;
  text-align: right;
   justify-items: right;
   align-items: center;
`;

export const ImagemApresentacao = styled(ApresentacaoImagem)`
   width: ${props => !props.scroll && '0%'};
   height: ${props => !props.scroll && '0%'};
   animation: ${props => props.scroll ? 'scale-up-tr 1s cubic-bezier(0.390, 0.575, 0.565, 1.000) both' : 'scale-up-tr-2 1s cubic-bezier(0.390, 0.575, 0.565, 1.000)'};
   
      @keyframes scale-up-tr {
      0% {
        -webkit-transform: scale(0.5);
                transform: scale(0.5);
        -webkit-transform-origin: 100% 0%;
                transform-origin: 100% 0%;
      }
      100% {
        -webkit-transform: scale(1);
                transform: scale(1);
        -webkit-transform-origin: 100% 0%;
                transform-origin: 100% 0%;
      }
    }
    
    
     @keyframes scale-up-tr-2 {
      0% {
        -webkit-transform: scale(1);
                transform: scale(1);
        -webkit-transform-origin: 100% 0%;
                transform-origin: 100% 0%;
      }
      100% {
        -webkit-transform: scale(0);
                transform: scale(0);
        -webkit-transform-origin: 100% 0%;
                transform-origin: 100% 0%;
      }
    }

`;